import { Action, Module, VuexModule } from "vuex-module-decorators";
import { NewsType } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class NewsTypeModule extends VuexModule {
    @Action
    [NewsType.findPageNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/newsType/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [NewsType.listNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/newsType/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [NewsType.saveNewsType](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/newsType/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [NewsType.deleteNewsType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/newsType/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}